import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import type { SectionExportGridApis } from "./exportSectionsWorkbook";
import { SECTION_EXPORT_EXCEL_STYLES } from "./sectionExportStyles";
import type { SectionsSheetRow } from "./sectionsSheet";
import type { SpecificationsSheetRow } from "./specificationsSheet";
import type { StandSetupsSheetRow } from "./standSetupsSheet";

export const SectionExportGrids = ({
	onGridsReady,
}: {
	onGridsReady: (apis: SectionExportGridApis) => void;
}) => {
	const apisRef = useRef<Partial<SectionExportGridApis>>({});

	const registerApi = (apis: Partial<SectionExportGridApis>) => {
		apisRef.current = { ...apisRef.current, ...apis };
		const { sections, standSetups, specifications } = apisRef.current;
		if (sections && standSetups && specifications)
			onGridsReady({ sections, standSetups, specifications });
	};

	return (
		<Box sx={{ display: "none" }}>
			<AgGridReact<SectionsSheetRow>
				excelStyles={SECTION_EXPORT_EXCEL_STYLES}
				onGridReady={(params) => registerApi({ sections: params.api })}
			/>
			<AgGridReact<StandSetupsSheetRow>
				excelStyles={SECTION_EXPORT_EXCEL_STYLES}
				onGridReady={(params) => registerApi({ standSetups: params.api })}
			/>
			<AgGridReact<SpecificationsSheetRow>
				excelStyles={SECTION_EXPORT_EXCEL_STYLES}
				onGridReady={(params) => registerApi({ specifications: params.api })}
			/>
		</Box>
	);
};
